<template>

<app-wrapper :fill="!events.length" class="events">

	<app-empty v-if="!events.length">{{ page.customer_events_empty }}</app-empty>

	<div class="events-list">

		<app-event v-for="(event, index) in events" :key="index" :item="event" class="events-item" />

	</div>

    <app-pagination :pages="pages" :current="current" v-on:change="onPageChange" />

</app-wrapper>

</template>

<script>

export default {

    data: function() {

        return {
            is: {
                loading: false
            },
            events: [],
            pages: 1,
            current: 1,
            total: 0
        }

    },

    created: function() {
      
        this.fetch()
        
    },

	methods: {

        onPageChange: function(value) {

            this.current = value
            this.fetch()

        },

        fetch: function() {

            this.is.loading = true

            this.$api.request('account/events', {
                page: this.current
            }).then(function(json) {

                this.events = json.items
                this.pages = json.pages
                this.current = json.page 
                this.total = json.total

                this.is.loading = false

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.is-mobile .events {
    padding: 0px!important;
}

.events-item {
    margin: 4px 4px 4px 4px!important;
    width: calc(25% - 8px)!important;
}

.is-tablet .events-item {
    margin: 4px 4px 4px 4px!important;
    width: calc(33% - 8px)!important;
}

.is-mobile .events-item {
    margin: 4px 4px 4px 4px!important;
    width: calc(50% - 8px)!important;
}

.events-list {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}

</style>